/**
 * The header every list surface opens with: a title, a line of mono facts
 * under it, the surface's own buttons on the right, and an optional chip row
 * whose end carries the one fact worth a glance (`picked`). There is no strip
 * of numbers: the group headers already count.
 */
import type { ReactNode } from "react";

export interface ListHeadProps {
  title: ReactNode;
  /** Mono facts under the title, one span each. */
  sub?: ReactNode[];
  /** Buttons on the right of the title. */
  acts?: ReactNode;
  /** The chip row under the header (settings at a glance). */
  chips?: ReactNode;
  /** The trailing fact at the end of the chip row. */
  picked?: ReactNode;
}

export function ListHead({ title, sub, acts, chips, picked }: ListHeadProps) {
  return (
    <div className="qhd">
      <div className="top">
        <div className="title">
          <h1>{title}</h1>
          {sub && sub.length > 0 && (
            <div className="sub">
              {sub.map((fact, index) => (
                <span key={index}>{fact}</span>
              ))}
            </div>
          )}
        </div>
        {acts != null && <div className="acts">{acts}</div>}
      </div>
      {(chips != null || picked != null) && (
        <div className="rhythm">
          {chips}
          {picked != null && <span className="fact picked">{picked}</span>}
        </div>
      )}
    </div>
  );
}
